import { useQuery } from '@tanstack/react-query'; // useQueryClient
import { ApplicationSettingsPayload } from './generated/types';
import { useContext } from 'react';
import AppContext from 'src/AppContext';

export const useThemeApplicationSetting = () => {
    const context = useContext(AppContext);

    const query = `query GetApplicationSettings {
    getApplicationSettings {
      settings {
        appKeys
        key
        value
      }
    }
  }`;

    return useQuery({
        queryKey: ['getApplicationSettings'],

        queryFn: async () => {

            try {
                const response = await (context.api.graphql({ query }) as Promise<{
                    data: {
                        getApplicationSettings: ApplicationSettingsPayload;
                    };
                }>);

                return response.data.getApplicationSettings.settings.find(item => item.key === 'theme')?.value;
            } catch (e: any) {
                // in case of errors, let's fall back to the default value
                return undefined;
            }
        },
    });
};
